'use strict';

import Alpine from 'alpinejs';

let isInitialized = false;
let jonitoPluginsLoaded = false;

const init = () => {
    if (isInitialized) {
        return;
    }

    // Set Alpine globally
    window.Alpine = Alpine;
    
    // Load Jonnitto plugins first
    loadJonnitoPlugins().then(() => {
        // Start Alpine after plugins are loaded
        Alpine.start();
        isInitialized = true;
    });
};

const loadJonnitoPlugins = () => {
    return new Promise((resolve) => {
        if (jonitoPluginsLoaded) {
            resolve();
            return;
        }

        // Load the complete Jonnitto script that includes all plugins
        const script = document.createElement('script');
        script.src = '/_Resources/Static/Packages/Jonnitto.PrettyEmbedPresentation/Scripts/Complete.js';
        script.onload = () => {
            jonitoPluginsLoaded = true;
            resolve();
        };
        script.onerror = () => {
            resolve();
        };
        document.head.appendChild(script);
    });
};

const reinitialize = () => {
    if (window.Alpine) {
        // Destroy existing components
        window.Alpine.destroyTree(document.body);
        
        // Wait for cleanup and reinitialize
        setTimeout(() => {
            window.Alpine.initTree(document.body);
        }, 50);
    }
};

const destroy = () => {
    if (window.Alpine) {
        // Clean up Alpine components
        window.Alpine.destroyTree(document.body);
    }
};

const isInitializedCheck = () => {
    return isInitialized;
};

export default {
    init,
    reinitialize,
    destroy,
    isInitialized: isInitializedCheck
};

